module.exports = __webpack_public_path__ + "static/media/PPTicon.6e71ea0e.svg";